import { format } from "date-fns";
import EventRow from "@/components/calendar/EventRow";
import EventList from "@/components/calendar/EventList";
import { daysIn, rangeFor, ymd, THEME } from "@/lib/calendar";

export const WeekGrid = ({ anchor, eventsByDate, variant, onOpen, today, audience }) => {
  const t = THEME[variant];
  const days = daysIn(rangeFor("week", anchor));
  return (
    <div data-testid="calendar-week-grid">
      <div className="hidden xl:grid grid-cols-7 gap-2">
        {days.map((d) => {
          const k = ymd(d);
          return (
            <div key={k} className={`rounded-xl border p-2 min-h-[220px] ${t.sub} ${k === today ? "ring-2 ring-cyan-500" : ""}`}>
              <p className="text-xs font-bold uppercase tracking-wide">{format(d, "EEE")}</p>
              <p className={`text-lg font-black mb-2 ${k === today ? t.accent : ""}`}>{format(d, "d")}</p>
              <div className="space-y-1.5">
                {(eventsByDate[k] || []).map((e) => (
                  <EventRow key={e.id} event={e} variant={variant} onOpen={onOpen} compact audience={audience} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <div className="xl:hidden">
        <EventList days={days} eventsByDate={eventsByDate} variant={variant} onOpen={onOpen} today={today} audience={audience} />
      </div>
    </div>
  );
};

export default WeekGrid;
